import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/api-response';
import { OrganizationUser } from '../../models/organization-user';

@Injectable({ providedIn: 'root' })
export class OrganizationUsersService {
  constructor(private http: HttpClient) {}

  getUsers(
    organizationId: string,
    page: number,
    size: number,
    search: string
  ): Observable<ApiResponse<OrganizationUser[]>> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (search.trim()) {
      params = params.set('search', search.trim());
    }

    return this.http.get<ApiResponse<OrganizationUser[]>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/users`,
      { params }
    );
  }

  createUser(
    organizationId: string,
    request: {
      fullName: string;
      email: string;
      role: number | null;
      receivesLicenceEmails: boolean;
    }
  ) {
    return this.http.post<ApiResponse<OrganizationUser>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/users`,
      request
    );
  }

  updateUser(
    organizationId: string,
    userId: string,
    request: {
      fullName: string;
      email: string;
      role: number | null;
      receivesLicenceEmails: boolean;
    }
  ) {
    return this.http.put<ApiResponse<OrganizationUser>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/users/${userId}`,
      request
    );
  }

  activateUser(organizationId: string, userId: string) {
    return this.http.post<ApiResponse<OrganizationUser>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/users/${userId}/activate`,
      {}
    );
  }

  disableUser(organizationId: string, userId: string) {
    return this.http.post<ApiResponse<OrganizationUser>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/users/${userId}/disable`,
      {}
    );
  }
}
